import type {RouteRecordRaw} from "vue-router";

export const routeName = 'CabinetTariffs';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'tariffs',
    component: () => import('@/pages/Tariffs'),
    meta: {
        isHide: true,
    }
};
